export function newFeesHistoryVisitor(driver, newestBlock, blockCount = 1, rewardPercentiles) {
    let currentBlockCount = blockCount;
    let currentRewardPercentiles = rewardPercentiles;
    return {
        get newestBlock() { return newestBlock; },
        count(blockCount) {
            if (blockCount !== undefined) {
                currentBlockCount = blockCount;
            }
            return this;
        },
        rewardPercentiles(percentiles) {
            currentRewardPercentiles = percentiles;
            return this;
        },
        get: () => driver.getFeesHistory(newestBlock, currentBlockCount, currentRewardPercentiles)
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVlcy12aXNpdG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2ZlZXMtdmlzaXRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFVBQVUscUJBQXFCLENBQ2pDLE1BQXFCLEVBQ3JCLFdBQTRCLEVBQzVCLFVBQVUsR0FBRyxDQUFDLEVBQ2QsaUJBQTRCO0lBRTVCLElBQUksaUJBQWlCLEdBQUcsVUFBVSxDQUFDO0lBQ25DLElBQUksd0JBQXdCLEdBQUcsaUJBQWlCLENBQUM7SUFFakQsT0FBTztRQUNILElBQUksV0FBVyxLQUFLLE9BQU8sV0FBVyxDQUFBLENBQUMsQ0FBQztRQUN4QyxLQUFLLENBQUMsVUFBbUI7WUFDckIsSUFBSSxVQUFVLEtBQUssU0FBUyxFQUFFO2dCQUMxQixpQkFBaUIsR0FBRyxVQUFVLENBQUM7YUFDbEM7WUFDRCxPQUFPLElBQUksQ0FBQztRQUNoQixDQUFDO1FBQ0QsaUJBQWlCLENBQUMsV0FBMEI7WUFDeEMsd0JBQXdCLEdBQUcsV0FBVyxDQUFDO1lBQ3ZDLE9BQU8sSUFBSSxDQUFDO1FBQ2hCLENBQUM7UUFDRCxHQUFHLEVBQUUsR0FBRyxFQUFFLENBQUMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxXQUFXLEVBQUUsaUJBQWlCLEVBQUUsd0JBQXdCLENBQUM7S0FDN0YsQ0FBQTtBQUNMLENBQUMifQ==